import { c as _c } from "react/compiler-runtime";
import { useCurrencies } from "@opensea/app-kit";
import { readFragment } from "@opensea/graphql";
import { Badge, Flex, Separator, Spinner, TimelineAvatar, TimelineContent, TimelineDescription, TimelineItem, TimelineSide, TimelineTitle } from "@opensea/ui-kit";
import { ApprovalDelegation, Check, CurrencyExchangeFilled, Draw, ErrorFilled, PriceCheck, Publish, ScanDelete, Send } from "@opensea/ui-kit/icons";
import { useMemo } from "react";
import { useTranslations } from "use-intl";
import { useSnapshot } from "valtio";
import { useIsEmbeddedWallet } from "../../polychain/hooks/useIsEmbeddedWallet";
import { FlowState } from "../../stores/flowStore";
import { Button } from "../Button";
import { ActionTimelineItemFragment } from "./ActionTimelineItem.fragment";
const DEFAULT_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkqAcAAIUAgUW0RjgAAAAASUVORK5CYII=";
export const ActionTimelineItem = t0 => {
  const $ = _c(44);
  const {
    action: actionKey,
    active,
    error,
    isLoading,
    isPending,
    isDone,
    retry,
    start,
    onBack
  } = t0;
  const action = readFragment(ActionTimelineItemFragment, actionKey);
  const {
    getCurrency
  } = useCurrencies();
  const t = useTranslations("wallet.ActionTimelineItem");
  const {
    flow
  } = useSnapshot(FlowState);
  const isClaim = flow?.isClaim ?? false;
  const isEmbeddedWallet = useIsEmbeddedWallet();
  const getAvatar = () => {
    switch (action.__typename) {
      case "BuyItemAction":
        {}
      case "SvmBuyItemsAction":
        {
          return action.items[0]?.imageUrl;
        }
      case "CreateOffersAction":
        {
          return action.items[0]?.imageUrl ? DEFAULT_IMAGE : null;
        }
      case "ItemApprovalAction":
        {
          return action.item.collection?.imageUrl;
        }
      case "BlurAuthAction":
        {
          return "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgY2xpcC1wYXRoPSJ1cmwoI2NsaXAwXzE5MDZfODE5KSI+CjxyZWN0IHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgZmlsbD0iYmxhY2siLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjUgMTEuNjA0MVY0LjMySDEwLjMwNTRMMTEuNzcwNyA1LjY4NjExVjcuNTI2OTFMMTEuMzUyOSA4LjAyMjc3TDExLjc3MDcgOC40NzQwNlYxMC4yNzgxTDEwLjMwMSAxMS42NDMxTDQuNSAxMS42MDUyVjExLjYwNDFaTTkuNjY2OTQgMTAuMTQ3N0wxMC4yMDQgOS42NTE4NlY5LjA1MDE0TDkuOTAzMTcgOC44MDA1NEg2LjA2NTU3VjEwLjEyNjVMOS42NjU4MyAxMC4xNDg4TDkuNjY2OTQgMTAuMTQ3N1pNOS44NzUzMSA3LjMxMDc0TDEwLjIwNCA3LjAwNDMxVjYuMzEyMzRMOS42NjM2IDUuODA5OEg2LjA2NjY5VjcuMzEwNzRIOS44NzUzMVpNMTguNjM4MSAxMi41OTkxTDIwLjEgMTMuOTY2NFYxNS45MDc1TDE5LjYxMzEgMTYuNDA4OUwyMC4xIDE2Ljg1MjRWMTkuODM4N0gxOC41MzMzVjE3LjQyOTZMMTguMjMyNSAxNy4xNzg5SDE0LjM5NzFWMTkuODM5OEgxMi44MzA0VjEyLjU5OTFIMTguNjM4MVpNMTcuOTk0IDE0LjA4NzhIMTQuMzk3MVYxNS42OTI0SDE4LjIwNTdMMTguNTMzMyAxNS4zODZWMTQuNTkxNUwxNy45OTQgMTQuMDg3OFpNMTkuODM4MSAxMS42NDJWMTAuMTUyMkgxNS4wODU3TDE0LjM5NDkgOS42MTI4NlY0LjMyMjIzSDEyLjgyOTNWMTAuMzE3MUwxNC41MjUyIDExLjY0MkgxOS44MzgxWk05LjQ3ODYzIDE4LjQzMDJMMTAuMTQwNSAxNy44OTg3VjEyLjYwMTRIMTEuNzA3MlYxOC41ODk1TDEwLjA1MTQgMTkuOTJINi4xNzU4OUw0LjUgMTguNTkxOFYxMi42MDE0SDYuMDY2NjlWMTcuODk0Mkw2Ljc0MzA2IDE4LjQzMDJIOS40Nzg2M1oiIGZpbGw9IndoaXRlIi8+CjwvZz4KPGRlZnM+CjxjbGlwUGF0aCBpZD0iY2xpcDBfMTkwNl84MTkiPgo8cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IndoaXRlIi8+CjwvY2xpcFBhdGg+CjwvZGVmcz4KPC9zdmc+Cg==";
        }
      case "MintAction":
        {
          return action.collection?.imageUrl;
        }
      default:
        {
          return null;
        }
    }
  };
  const getIcon = () => {
    switch (action.__typename) {
      case "AcceptOfferAction":
        {}
      case "Permit2SignatureAction":
        {
          return ApprovalDelegation;
        }
      case "CreateCollectionOfferAction":
        {}
      case "CreateListingsAction":
        {}
      case "CreateOfferAction":
        {}
      case "CreateOffersAction":
        {}
      case "ItemApprovalAction":
        {}
      case "MintAction":
        {
          return Draw;
        }
      case "PaymentApprovalAction":
        {
          return PriceCheck;
        }
      case "TransferAssetsAction":
        {
          return Send;
        }
      case "CancelOrdersAction":
        {}
      case "GaslessCancelOrdersAction":
        {}
      case "CancelAllOrdersAction":
        {
          return ScanDelete;
        }
      case "RefreshAction":
        {
          return Draw;
        }
      case "WrapAction":
        {}
      case "UnwrapAction":
        {}
      case "SwapAssetsAction":
        {}
      case "SvmSwapAssetsAction":
        {
          return CurrencyExchangeFilled;
        }
      case "DropPublishAction":
        {
          return Publish;
        }
      default:
        {
          return;
        }
    }
  };
  let t1;
  if ($[0] !== getCurrency) {
    t1 = (chain, to, wrappedNativeCurrency) => {
      const currencyIdentifier = {
        chainIdentifier: chain,
        contractAddress: to
      };
      const currency = getCurrency(currencyIdentifier);
      return currency?.symbol ?? wrappedNativeCurrency?.symbol ?? "";
    };
    $[0] = getCurrency;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getWrapSymbol = t1;
  const getTitle = () => {
    switch (action.__typename) {
      case "BuyItemAction":
        {}
      case "SvmBuyItemsAction":
        {
          return isClaim ? t("claimItem", {
            count: action.items.length
          }) : t("buyItem", {
            count: action.items.length
          });
        }
      case "AcceptOfferAction":
        {
          return t("acceptOffer", {
            count: action.items.length
          });
        }
      case "ItemApprovalAction":
        {
          return t("approveCollection");
        }
      case "PaymentApprovalAction":
        {
          return t("approveCurrency", {
            symbol: action.currency.symbol
          });
        }
      case "CreateListingsAction":
        {
          return t("createListing", {
            count: action.items.length
          });
        }
      case "CreateOfferAction":
        {
          return t("createOffer");
        }
      case "CreateOffersAction":
        {
          return t("createOffer", {
            count: action.items.length
          });
        }
      case "CreateCollectionOfferAction":
        {
          const hasTraits = flow?.type === "create-collection-offer" && (flow.trait || flow.traits && flow.traits.length > 0);
          return hasTraits ? t("createTraitOffer") : t("createCollectionOffer");
        }
      case "TransferAssetsAction":
        {
          return t("approveTransfer");
        }
      case "BlurAuthAction":
        {
          return t("signBlurAuth");
        }
      case "GaslessCancelOrdersAction":
        {
          return t("signCancelOrder");
        }
      case "CancelOrdersAction":
        {
          return t("approveOrderCancellation");
        }
      case "CancelAllOrdersAction":
        {
          return t("approveAllOrderCancellations");
        }
      case "RefreshAction":
        {
          return t("completePriorTasks");
        }
      case "WrapAction":
        {
          const toSymbol = getWrapSymbol(action.transactionSubmissionData.chain.identifier, action.transactionSubmissionData.to, action.transactionSubmissionData.chain.wrappedNativeCurrency);
          return t("wrapToken", {
            from: action.transactionSubmissionData.chain.nativeCurrency.symbol,
            to: toSymbol
          });
        }
      case "UnwrapAction":
        {
          const fromSymbol = getWrapSymbol(action.transactionSubmissionData.chain.identifier, action.transactionSubmissionData.to, action.transactionSubmissionData.chain.wrappedNativeCurrency);
          return t("unwrapToken", {
            from: fromSymbol,
            to: action.transactionSubmissionData.chain.nativeCurrency.symbol
          });
        }
      case "SwapAssetsAction":
        {}
      case "SvmSwapAssetsAction":
        {
          return t("swapTokens");
        }
      case "MintAction":
        {
          return t("signToMint");
        }
      case "DropPublishAction":
        {
          return t("dropPublishAction");
        }
      case "Permit2SignatureAction":
        {
          return t("permit2SignatureAction");
        }
      case "ClaimTokenRewardAction":
        {
          return t("claimToken");
        }
      default:
        {
          return t("unknown");
        }
    }
  };
  const getDescription = () => {
    switch (action.__typename) {
      case "ItemApprovalAction":
        {
          return t("approveCollectionDescription");
        }
      case "BlurAuthAction":
        {
          return t("blurAuthDescription");
        }
      default:
        {
          return "";
        }
    }
  };
  const src = getAvatar();
  let t2;
  if ($[2] !== getIcon) {
    t2 = getIcon();
    $[2] = getIcon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const icon = t2;
  let t3;
  bb0: {
    if (src) {
      let t4;
      if ($[4] !== src) {
        t4 = {
          src
        };
        $[4] = src;
        $[5] = t4;
      } else {
        t4 = $[5];
      }
      t3 = t4;
      break bb0;
    }
    if (icon) {
      let t4;
      if ($[6] !== icon) {
        t4 = {
          icon
        };
        $[6] = icon;
        $[7] = t4;
      } else {
        t4 = $[7];
      }
      t3 = t4;
      break bb0;
    }
    let t4;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = {
        src: DEFAULT_IMAGE
      };
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = t4;
  }
  const avatarProps = t3;
  const showAvatar = action.__typename !== "ClaimTokenRewardAction";
  const T0 = TimelineItem;
  const t4 = "gap-3 md:gap-4";
  let t5;
  if ($[9] !== avatarProps || $[10] !== showAvatar) {
    t5 = showAvatar && <TimelineAvatar {...avatarProps} />;
    $[9] = avatarProps;
    $[10] = showAvatar;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  const T1 = TimelineContent;
  const T2 = TimelineTitle;
  const t6 = getTitle();
  let t7;
  if ($[12] !== T2 || $[13] !== t6) {
    t7 = <T2>{t6}</T2>;
    $[12] = T2;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== getDescription) {
    t8 = getDescription();
    $[15] = getDescription;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t8) {
    t9 = <TimelineDescription>{t8}</TimelineDescription>;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== T1 || $[20] !== t7 || $[21] !== t9) {
    t10 = <T1>{t7}{t9}</T1>;
    $[19] = T1;
    $[20] = t7;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== action || $[24] !== active || $[25] !== error || $[26] !== isClaim || $[27] !== isDone || $[28] !== isEmbeddedWallet || $[29] !== isLoading || $[30] !== isPending || $[31] !== onBack || $[32] !== retry || $[33] !== start || $[34] !== t) {
    t11 = active ? isLoading ? <Spinner /> : error ? <Flex className="gap-2 md:gap-3"><Badge icon={ErrorFilled} variant="error">{error}</Badge><Separator className="h-6" orientation="vertical" />{onBack ? <Button onClick={onBack} size="sm" variant="secondary">{t("reset")}</Button> : null}<Button onClick={retry} size="sm">{t("retry")}</Button></Flex> : <Button isLoading={isPending} onClick={start} size="sm">{action.__typename === "BuyItemAction" || action.__typename === "SvmBuyItemsAction" ? isClaim ? t("claim") : t("buy") : action.__typename === "AcceptOfferAction" ? t("accept") : isEmbeddedWallet ? t("confirm") : t("confirmInWallet")}</Button> : isDone ? <Check size={24} /> : null;
    $[23] = action;
    $[24] = active;
    $[25] = error;
    $[26] = isClaim;
    $[27] = isDone;
    $[28] = isEmbeddedWallet;
    $[29] = isLoading;
    $[30] = isPending;
    $[31] = onBack;
    $[32] = retry;
    $[33] = start;
    $[34] = t;
    $[35] = t11;
  } else {
    t11 = $[35];
  }
  let t12;
  if ($[36] !== t11) {
    t12 = <TimelineSide className="max-w-[60%]">{t11}</TimelineSide>;
    $[36] = t11;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== T0 || $[39] !== active || $[40] !== t10 || $[41] !== t12 || $[42] !== t5) {
    t13 = <T0 active={active} className={t4}>{t5}{t10}{t12}</T0>;
    $[38] = T0;
    $[39] = active;
    $[40] = t10;
    $[41] = t12;
    $[42] = t5;
    $[43] = t13;
  } else {
    t13 = $[43];
  }
  return t13;
};